import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';
declare var bootbox:any;
declare var window:any;
declare var $:any;
@Component({
  selector: 'app-survey-management',
  template: require('./survey-management.component.html')
})
export class SurveyManagementComponent extends BaseComponent implements OnInit {

  public surveyId = -1;
  public survey = {
    title: ""
  };

  public questions = [];

  public surveys = [];

  public selectedSurvey = null;

  public updateSlaves() {
    $(".slavecheck").prop("checked", $(".mastercheck").prop("checked"));
  }

  public copyQuestions() {
    if($(".slavecheck:checked").length<=0) {
      bootbox.alert("Please select at least one question to copy");
      return;
    }
    $('#selectSurvey').modal('show');
  }

  public confirmCopyQuestions() {
    $('#selectSurvey').modal('hide');

    var qids = [];
    $(".slavecheck:checked").each(function(){
      qids.push($(this).val());
    });

    var surveyId = this.selectedSurvey.surveyId;

    this.busy = this.lsApi.copyQuestions(qids.join(","), surveyId).subscribe(resp => {
        if(resp.status) {
            bootbox.alert("Questions successfully copied!");
        }
    },
    error => {
        console.log(error);
    });
  }

  public loadSurveys() {
    this.busy = this.lsApi.getSurveys().subscribe(resp => {
        if(resp.status) {
            this.surveys = resp.data;
            for(var i=0;i<this.surveys.length;i++) {
              if(this.surveys[i].surveyId == this.surveyId) {
                this.surveys.splice(i,1);
                break;
              }
            }
            if(this.surveys.length>0)
              this.selectedSurvey = this.surveys[0];
            //this.router.navigate([this.router.url]);
        }
    },
    error => {
        console.log(error);
    });
  }

  public enableSortable() {
    setTimeout(function(){
      window.sortable(".sortable",{
                  orientation: 'vertical',
                  items: '.items',
                  forcePlaceholderSize: true
                  });

      window.sortable('.sortable')[0].addEventListener('sortupdate', function(e) {

        e = e.detail;

        setTimeout(()=>{
        //for(i=0;i<e.destination.items.length;i++) {
            var inps = $(e.destination.items);
            for(var k=0;k<inps.length;k++){
                var x = $(inps[k]);
                var span = x.find(".currentOrder");
                x.data("index", (k+1));
                span.html((k+1) + "");
            }
        },0);

      //console.log(e.detail);
      });
    },0);
  }

  public saveOrder() {
    var qorders = [];
    $(".items").each(function(index, element){
      var newOrder = $(element).data("index");
      var oldOrder = $(element).data("qorder");
      var qid = $(element).data("qid");
      if(oldOrder != newOrder)
        qorders.push({
          qid: qid,
          order: newOrder
        });
    });

    //console.log(qorders);

    this.busy = this.lsApi.saveQuestionOrder(JSON.stringify(qorders)).subscribe(resp => {
      if(resp.status) {
        bootbox.alert("Question Order Successfully Saved");
        this.loadSurveyQuestions();
      }
    },
    error => {
        console.log(error);
    });
  }

  public preview(surveyId, isManager, qid) {
    this.busy = this.lsApi.generateSurveyPreview(surveyId, isManager).subscribe(resp => {
      if(resp.status) {
        var url = resp.data[0] + "/" + qid;
        bootbox.confirm({
          message: "Below is the link for the preview.<br><br><b>Link:</b> https://leadershipmatters.briviaconsulting.com" + url,
          buttons: {
              confirm: {
                  label: 'Open Preview',
                  className: 'btn-primary'
              },
              cancel: {
                  label: 'Close',
                  className: 'btn-default'
              }
          },
          callback: function (result) {
            if(result)
              window.open(url);
          }
      });

          //this.surveys = resp.data;
          //this.router.navigate([this.router.url]);
      }
  },
  error => {
      console.log(error);
  });
  }
  

  public getQuestionType(question) {
    switch(question.type) {
      case 0: // 1 to 10 options
        return "Select One Option";
      case 1: // Text Question
        return "Open Text";
      case 2: // 1 to 10 options
        return "Select exactly 'n' options";
    }

  }
  
  ngOnInit() {
    super.ngOnInit();
  }

  routeParamsUpdated() {
    this.surveyId = this.currentRouteParams["surveyId"];
    this.loadSurveyById();
    this.loadSurveyQuestions();
    this.loadSurveys();
  }

  public loadSurveyById() {
    this.busy = this.lsApi.getSurveyById(this.surveyId).subscribe(resp => {
        if(resp.status) {
            this.survey = resp.data[0];
        }
    },
    error => {
        console.log(error);
    });
  }

  public loadSurveyQuestions() {
    this.busy = this.lsApi.getSurveyQuestions(this.surveyId).subscribe(resp => {
        if(resp.status) {
            this.questions = resp.data;
            this.enableSortable();
        }
    },
    error => {
        console.log(error);
    });
  }

  
  public deleteQuestion(q) {

    bootbox.confirm({message:"Do you want to delete '" + q.title + "' question and all it's data?<br><small>All their data will be lost. This cannot be undone.</small>",
    buttons: {
        confirm: {
            label: 'Yes',
            className: 'btn-primary'
        },
        cancel: {
            label: 'No',
            className: 'btn-primary btn-simple'
        }
    },
    callback: (result) => {
        if(result) {

          this.busy = this.lsApi.deleteQuestionById(q.surveyQuestionId).subscribe(resp => {
              if(resp.status) {
                this.appToast.success("Question Successfully Deleted","Question Deleted");
                this.loadSurveyQuestions();
              }
          },
          error => {
              console.log(error);
          });

        }
      }});
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/survey-management/survey-management.component.ts